<template>
  <modal-provider
    name="welcome-friends-modal"
    :width="500"
    @opened="opened"
    @before-open="beforeOpen"
  >
    <template v-slot:modal-heading>
      <div class="welcome-friends-modal__header">
        <p class="welcome-friends-modal__header-text" v-html="$t('welcome_friends_modal_title')"></p>
      </div>
    </template>
    <div class="welcome-friends-modal__body">
      <p class="welcome-friends-modal__body-text" v-html="$t('welcome_friends_modal_text')"></p>
      <div class="welcome-friends-modal__body-copy-block">
        <p class="welcome-friends-modal__body-copy-text" ref="text" v-html="$t('welcome_friends_modal_copy_text')"></p>
      </div>
      <div class="welcome-friends-modal__body-button-wrap">
        <copy-to-clipboard-button
          :text-for-copy="textForCopy"
          @success="handleSuccessCopy"
          @unsuccess="handleUnsuccessCopy"
          class="welcome-friends-modal__body-copy-button"
        >
          <svg width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M9.00088 15.5H1.50088C1.09894 15.514 0.709236 15.3604 0.424843 15.076C0.140458 14.7916 -0.0130892 14.4019 0.000875839 14V6.50001C-0.0130892 6.09807 0.140458 5.70837 0.424843 5.42399C0.709236 5.1396 1.09894 4.98605 1.50088 5.00002H4.50088V2.00002C4.48691 1.59807 4.64046 1.20837 4.92484 0.92399C5.20924 0.639597 5.59894 0.48605 6.00088 0.500022H13.5009C13.9028 0.48605 14.2925 0.639597 14.5769 0.92399C14.8613 1.20837 15.0148 1.59807 15.0009 2.00002V9.50001C15.0146 9.90187 14.861 10.2915 14.5767 10.5758C14.2924 10.8601 13.9027 11.0137 13.5009 11H10.5009V14C10.5146 14.4019 10.361 14.7915 10.0767 15.0758C9.79236 15.3601 9.40273 15.5137 9.00088 15.5ZM1.50088 6.50001V14H9.00088V11H6.00088C5.599 11.0137 5.20943 10.8601 4.92509 10.5758C4.64075 10.2915 4.48714 9.90187 4.50088 9.50001V6.50001H1.50088ZM6.00088 2.00002V9.50001H13.5009V2.00002H6.00088Z" fill="#333333"/>
          </svg>
          {{ $t('welcome_friends_modal_btn_text') }}
        </copy-to-clipboard-button>
        <span
          v-if="result"
          class="welcome-friends-modal__body-result-text"
          :class="{'welcome-friends-modal__body-result-text--error': !result.success}"
        >
          {{ result.message }}
        </span>
      </div>
    </div>
  </modal-provider>
</template>

<script>
import CopyToClipboardButton from '@/components/helpers/CopyToClipboardButton'

export default {
  name: 'WelcomeFriendsModal',
  props: {
    nextModalShowing: {
      type: Number,
      required: true
    },
    delayShowing: {
      type: Number,
      required: true
    }
  },
  components: { CopyToClipboardButton },
  data () {
    return {
      textForCopy: '',
      result: null
    }
  },
  methods: {
    handleSuccessCopy () {
      this.result = {
        success: true,
        message: this.$t('welcome_friends_modal_success_copy')
      }

      this.clearResult()
    },
    handleUnsuccessCopy () {
      this.result = {
        success: false,
        message: this.$t('welcome_friends_modal_unsuccess_copy')
      }

      this.clearResult()
    },
    clearResult () {
      setTimeout(() => {
        this.result = null
      }, 2000)
    },
    opened () {
      this.textForCopy = this.$refs.text.innerText
    },
    beforeOpen () {
      localStorage.setItem(
        'nextWelcomeFriendsModal',
        this.nextModalShowing.toString()
      )
    },
    canDisplay () {
      const currentTime = new Date().getTime() / 1000
      const welcomeBonusShowingTime =
        localStorage.getItem('nextWelcomeFriendsModal') || 0

      if (currentTime <= welcomeBonusShowingTime) { return false }

      const popupDisplayTime = JSON.parse(localStorage.getItem('modalsDisplayTimestamp') ?? '{}')
      if (((popupDisplayTime['welcome-bonus-modal'] ?? 0) / 1000) + 5 * 60 > currentTime) { return false }
      return true
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.canDisplay()) {
        this.$modal.show('welcome-friends-modal')
      }
    }, this.delayShowing)
  }
}
</script>

<style scoped lang="sass">

.welcome-friends-modal__header
  display: block
  width: 100%
  position: absolute
  top: 0
  left: 0
  background-color: #FFBC10
  padding: 40px 20px 35px

  +mmin(450)
    padding: 40px 35px 35px

  +mmin($small)
    padding: 65px 50px 55px

.welcome-friends-modal__header-text
  text-transform: uppercase
  font-size: 24px
  font-weight: 700
  margin: 0

  +mmin($phone)
    font-size: 30px

  +mmin($small)
    font-size: 46px

.welcome-friends-modal__body
  padding: 110px 5px 5px

  +mmin($phone)
    padding: 130px 5px 5px

  +mmin($small)
    padding: 220px 20px 0

.welcome-friends-modal__body-copy-block
  background-color: #f8f8f8
  padding: 20px
  margin-bottom: 20px

  +mmin($small)
    margin-bottom: 40px

.welcome-friends-modal__body-button-wrap
  display: flex
  align-items: center

.welcome-friends-modal__body-text,
.welcome-friends-modal__body-copy-text
  margin: 0
  font-weight: 500

.welcome-friends-modal__body-text
  margin-bottom: 20px

.welcome-friends-modal__body-copy-button
  display: flex
  align-items: center

  svg
    margin-right: 10px

  &:hover
    svg path
      fill: #fff

.welcome-friends-modal__body-result-text
  font-weight: 500
  font-size: 14px
  color: $nd-green-text-color
  margin-left: 20px

  &--error
    color: $nd-error-text-color
</style>
